"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mkSettingReliably = exports.mkSetting = void 0;
var shared_1 = require("../../shared");
function mkSetting(candidate) {
    if (!(0, shared_1.validate)(candidate)) {
        return null;
    }
    return {
        key: candidate.key,
        value: parseValue(candidate.value),
        priority: candidate.priority || 0,
        filter: candidate.filter || {},
    };
}
exports.mkSetting = mkSetting;
function mkSettingReliably(candidate) {
    return mkSetting(candidate);
}
exports.mkSettingReliably = mkSettingReliably;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function parseValue(value) {
    if (typeof value !== 'string') {
        return value;
    }
    try {
        return JSON.parse(value);
    }
    catch (e) {
        return value;
    }
}
//# sourceMappingURL=conversion.js.map